import gql from 'graphql-tag';
import * as fragments from './policy.query.fragments';

export const CONFIRM = gql`
  mutation confirmPolicyChange($policyId: ID!, $previewId: ID!, $internalNotes: String!) {
    confirmPolicyChange(policyId: $policyId, previewId: $previewId, internalNotes: $internalNotes) {
      success
      reason
    }
  }
`;

export const SUBMIT_CHANGES_FOR_APPROVAL = gql`
  mutation sendPolicyChangesForApprovalCommunication(
    $policyId: ID!
    $policyPreviewLink: String!
    $policyChangesDescription: String!
    $customerName: String!
  ) {
    sendPolicyChangesForApprovalCommunication(args: {
      policyId: $policyId
      policyPreviewLink: $policyPreviewLink
      policyChangesDescription: $policyChangesDescription
      customerName: $customerName
    }) {
      success
    }
  }
`;

export const REQUEST_TO_RESUBMIT_POLICY_CHANGES_FOR_APPROVAL = gql`
  mutation sendResubmitChangesForApprovalCommunication($policyLink: String!, $agentUsername: String!) {
    sendResubmitChangesForApprovalCommunication(args: { policyLink: $policyLink, agentUsername: $agentUsername }) {
      success
      agentEmail
    }
  }
`;

export const SEND_APPROVED_REQUESTED_CHANGES_COMMUNICATION = gql`
  mutation sendApprovedRequestedChangesCommunication($policyId: ID!, $agentUsername: String!) {
    sendApprovedRequestedChangesCommunication(args: { policyId: $policyId, agentUsername: $agentUsername }) {
      success
    }
  }
`;

export const CHANGE_POLICY = gql`
  mutation previewPolicyChangePolicy($policy: PolicyInput!) {
    previewPolicyChangePolicy(policy: $policy) {
      ...PolicyPreviewResponse
    }
  }
  ${fragments.PolicyPreviewResponse}
`;

export const ADD_SEGMENT = gql`
  mutation previewPolicyChangeAddSegment($policyId: ID!, $segment: PolicyDetailsInput!) {
    previewPolicyChangeAddSegment(policyId: $policyId, segment: $segment) {
      ...PolicyPreviewResponse
    }
  }
  ${fragments.PolicyPreviewResponse}
`;
export const CHANGE_SEGMENT = gql`
  mutation previewPolicyChangeToSegment($policyId: ID!, $segmentId: ID!, $segment: PolicyDetailsInput!) {
    previewPolicyChangeToSegment(policyId: $policyId, segmentId: $segmentId, segment: $segment) {
      ...PolicyPreviewResponse
    }
  }
  ${fragments.PolicyPreviewResponse}
`;

export const ADD_HOLD_CARD = gql`
  mutation addHoldCard($policyId: ID!, $reason: String!) {
    addHoldCard(policyId: $policyId, reason: $reason) {
      policyId
      createdBy
      createdDate
      reason
      deleted
      success
      holdCardId
    }
  }
`;
export const PREVIEW_POLICY_CHANGE_SCRUB_INCIDENTS = gql`
  mutation previewPolicyChangeScrubIncidents($policy: ScrubIncidentsInput!, $incidentDates: [AWSDate]!) {
    previewPolicyChangeScrubIncidents(policyData: $policy, incidentDates: $incidentDates) {
      id
      coverageChange
      itemsChanged
      itemsChangedAddendum
      billingDescription
      newPremium
      newTotalPrice
    }
  }
`;
export const GET_HOLD_CARDS = gql`
  query ($policyId: ID!) {
    holdcards: getHoldCards(policyId: $policyId) {
      holdCardId
      createdBy
      createdDate
      reason
      deleted
      policyId
    }
  }
`;

export const REMOVE_HOLD_CARD = gql`
  mutation removeHoldCard($policyId: ID!, $holdCardId: ID!) {
    removeHoldCard(policyId: $policyId, holdCardId: $holdCardId) {
      holdCardId
      deleted
      policyId
    }
  }
`;

export const RECREATE_APPLICATION = gql`
  mutation recreatePolicyApplication($policyId: ID!) {
    pdfUrl: recreatePolicyApplication(policyId: $policyId)
  }
`;

export const GET_POLICY_PAID_AND_PENDING = gql`
  query ($policyId: ID!) {
    PolicyPaidAndPendingCash: getPolicyPaidAndPendingCash(policyId: $policyId) {
      currentTotalPaid
      pendingAmount
    }
  }
`;

export const GET_RENEWAL_POLICY_ID = gql`
  query ($policyId: ID!) {
    renewalPolicyId: getRenewalPolicyId(policyId: $policyId)
  }
`;

export const GET_RENEWAL_PRICE_COMPARISON_DETAILS = gql`
  query ($currentPolicyId: ID!, $previousPolicyId: ID!) {
    RenewalPriceComparisonDetails: getRenewalPriceComparisonDetails(
      currentPolicyId: $currentPolicyId
      previousPolicyId: $previousPolicyId
    ) {
      increaseStateRateChange
      increaseMultiplePolicyDiscountRemoved
      increaseConnectedHomeDiscountRemoved
      increaseDwellingAmountIncreased
      increaseNumberOfClaims
      increaseSurplusContributionIncrease
      increasePriorMidTermChanges
      increaseFees
      increaseRoofAge
      increaseCommunityDriveScoreDecreased
      currentUBIAverage
      currentCommunityDrivers
      eligibleCommunityDrivers
      increaseCommunityDriveRemoved
      increaseInventoryDiscountRemoved
      increaseGoodPayerDiscountRemoved
      increaseNewHomeDiscountRemoved
      increaseSeniorCitizenDiscountRemoved
      increaseStudentAwayDiscountRemoved
      increaseGoodStudentDiscountRemoved
      increaseFiveYearClaimFreeDiscountRemoved
      increaseSafeDrivingDiscountRemoved
      increasePaperlessDiscountRemoved
      increaseCancellationOrReinstatementOnPriorTerm
      increaseHomeAge
      increasePaymentMethodChanged
      increaseCommunityPledgeDiscountRemoved
      currentSavingsMultiplePolicyDiscount
      currentSavingsConnectedHomeDiscount
      currentSavingsCommunityDriveDiscount
      currentSavingsGoodPayerDiscount
      currentSavingsNewHomeDiscount
      currentSavingsSeniorCitizenDiscount
      currentSavingsStudentAwayDiscount
      currentSavingsGoodStudentDiscount
      currentSavingsFiveYearClaimFreeDiscount
      currentSavingsSafeDrivingDiscount
      currentSavingsPaperlessDiscount
      currentSavingsCommunityPledgeDiscount
      savingsOpportunitiesConnectedHome
      savingsOpportunitiesBundleAuto
      savingsOpportunitiesBundleHome
      multiplePolicyDiscountImpact
      savingsOpportuntiesCoverageCounseling
      savingsOpportunitiesCommunityDriveLogMoreTrips
      savingsOpportunitiesAddDriversToCommunityDrive
      savingsOpportunitiesCommunityDriveImproveScore
      savingsOpportunitiesGoPaperless
      savingsOpportunitiesSwitchToOneTimePayments
      savingsOpportunitiesGetVouchedFor
      logMoreTripsImpact
      currentNumberOfVouches
    }
  }
`;

export const ORDER_INSPECTION = gql`
  mutation orderInspection(
    $policyId: ID!
    $address: AddressDetailsInput!
    $mailingAddress: AddressDetailsInput!
    $fname: String!
    $lname: String!
    $phone: String!
    $coverageA: Float!
    $effectiveDate: String!
  ) {
    inspection: orderInspection(
      policyId: $policyId
      address: $address
      mailingAddress: $mailingAddress
      fname: $fname
      lname: $lname
      phone: $phone
      coverageA: $coverageA
      effectiveDate: $effectiveDate
    ) {
      ... on OrderInspectionSuccess {
        dateOrdered
        status
        policyId
        caseNumber
        inspectionId
      }
      ... on OrderInspectionError {
        error
      }
    }
  }
`;

export const GET_INSPECTION_STATUS = gql`
  query ($policyId: ID!) {
    inspection: getInspectionStatus(policyId: $policyId) {
      status
      caseNumber
      inspectionId
      dateOrdered
      dateCompleted
      completedType
    }
  }
`;

export const GET_CD_DIFF = gql`
  query ($policyId: String!, $policyPreviewId: String!) {
    requests: getPolicyPreviewCdRequestData(policyId: $policyId, policyPreviewId: $policyPreviewId) {
      diff
      requestIdAfterPreview
      requestIdBeforePreview
      xmlBeforePreview {
        success
        message
        data
      }
      xmlAfterPreview {
        success
        message
        data
      }
    }
  }
`;

export const GET_BIX_CONVERSION_SIGNATURE_FROM_TABLE = gql`
  query getBixConversationSignatureFromTable($policyId: ID!) {
    getBixConversationSignatureFromTable(policyId: $policyId) {
      policyId
      signedTimestampISO8601
    }
  }
`;

export const GET_PALOMAR_POLICY_DOC = gql`
  query getPalomarPolicyDoc($palomarPolicyId: String!, $repEmail: String!, $policyType: String!) {
    palomarPolicyDoc: getPalomarPolicyDoc(
      palomarPolicyId: $palomarPolicyId
      repEmail: $repEmail
      policyType: $policyType
    ) {
      palomarPolicyDecPage
    }
  }
`;

export const REWRITE_POLICY = gql`
  mutation rewritePolicy($policyId: ID!, $newEffectiveDate: AWSDate!, $internalNotes: String, $newPolicyId: String) {
    rewritePolicy(
      policyId: $policyId
      newEffectiveDate: $newEffectiveDate
      internalNotes: $internalNotes
      newPolicyId: $newPolicyId
    ) {
      success
      message
    }
  }
`;

export const GENERATE_MEMBER_FORM = gql`
    mutation generateMemberForm($documentType: String!, $memberEmail: String, $policyId: ID!, $previewId: ID!) {
    generateMemberForm(args: {
      documentType: $documentType
      memberEmail: $memberEmail
      policyId: $policyId
      previewId: $previewId
    }) {
      documentLink
    }
  }
`;
